import * as React from 'react';

import { Image, type ImageProps } from '@/hen-ui/atomics/Image';

export type SliderImageProps = Omit<ImageProps, 'className'>;

/**
 * SliderImage - Composite component wrapper for Image component used in ImageGrid Slider
 *
 * Wraps GridImage with slider-specific layout structure to ensure images
 * display correctly within ImageGrid's slider layout.
 *
 * @example
 * ```tsx
 * <ImageGrid variant="slider">
 *   <SliderImage src="/image.jpg" alt="Image" />
 *   <SliderImage src="/image2.jpg" alt="Image 2" />
 * </ImageGrid>
 * ```
 */
export const SliderImage = React.forwardRef<HTMLImageElement, SliderImageProps>(
  ({ width, height, ...props }, ref) => {
    return (
      <div className='flex-none flex items-center justify-center'>
        <Image ref={ref} {...props} objectFit='contain' />
      </div>
    );
  },
);

SliderImage.displayName = 'SliderImage';
